/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Input } from 'ui/atoms/Input/Input';
import { Select } from 'ui/atoms/Select/Select';

import styles from './HubFilters.module.scss';

import type { HubFiltersProps } from './HubFilters.types';

const ALL = 'all';

export const HubFilters = ({
  query,
  onQuery,
  groups,
  activeGroup,
  onGroup,
  subgroups,
  activeSubgroup,
  onSubgroup,
  resultLabel,
  className,
}: HubFiltersProps) => {
  const { t } = useInt();

  return (
    <div className={cn(styles['filters'], className)}>
      {groups.length > 0 && (
        <div className={styles['pills']} role="group" aria-label={t('Filter by group')}>
          {[{ slug: ALL, title: t('All') }, ...groups].map((group) => (
            <button
              key={group.slug}
              type="button"
              className={cn(styles['pill'], activeGroup === group.slug && styles['selected'])}
              aria-pressed={activeGroup === group.slug}
              onClick={() => onGroup(group.slug)}
            >
              {group.title}
            </button>
          ))}
        </div>
      )}

      <div className={styles['toolbar']}>
        <Input
          fullWidth
          size="lg"
          htmlType="search"
          icon="search"
          value={query}
          onChange={onQuery}
          onClear={() => onQuery('')}
          placeholder={t('Search topics...')}
          ariaLabel={t('Search topics')}
          className={styles['search']}
        />

        {subgroups.length > 0 && (
          <Select
            size="lg"
            value={activeSubgroup}
            onChange={onSubgroup}
            options={[
              { value: ALL, title: t('All families') },
              ...subgroups.map((option) => ({ value: option.slug, title: option.label })),
            ]}
            className={styles['select']}
            dropdownClassName={styles['dropdown']}
          />
        )}
      </div>

      {resultLabel && <p className={styles['count']}>{resultLabel}</p>}
    </div>
  );
};
